import type { FechaISO } from "./tipos";

const MS_DIA = 24 * 60 * 60 * 1000;

const dosCifras = (n: number) => String(n).padStart(2, "0");

/** "YYYY-MM-DD" en la zona horaria local del dispositivo. */
export const aFechaISO = (d: Date): FechaISO =>
  `${d.getFullYear()}-${dosCifras(d.getMonth() + 1)}-${dosCifras(d.getDate())}`;

/** Medianoche local del día de `d`. */
export const inicioDelDia = (d: Date): Date =>
  new Date(d.getFullYear(), d.getMonth(), d.getDate());

/** Acepta "YYYY-MM-DD" o un ISO con hora; devuelve la medianoche local de ese día. */
export const diaDe = (valor: string): Date => {
  const soloFecha = /^(\d{4})-(\d{2})-(\d{2})$/.exec(valor);
  if (soloFecha) {
    return new Date(+soloFecha[1], +soloFecha[2] - 1, +soloFecha[3]);
  }
  return inicioDelDia(new Date(valor));
};

/** Días naturales entre dos fechas (b − a), sin tener en cuenta la hora. */
export const diasEntre = (a: Date, b: Date): number =>
  Math.round((inicioDelDia(b).getTime() - inicioDelDia(a).getTime()) / MS_DIA);

export const sumarDias = (d: Date, dias: number): Date => {
  const r = new Date(d);
  r.setDate(r.getDate() + dias);
  return r;
};

/** Lunes de la semana de `d` (semana europea). */
export const inicioDeSemana = (d: Date): Date => {
  const dia = inicioDelDia(d);
  const desplazamiento = (dia.getDay() + 6) % 7; // lunes = 0
  return sumarDias(dia, -desplazamiento);
};
